import React, { useState } from 'react';
import LoginPage from './pages/LoginPage';
import VisitListPage from './pages/VisitListPage';
import ResultPage from './pages/ResultPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import AdminUsersPage from './pages/AdminUsersPage';
import AdminDatKhamPage from './pages/AdminDatKhamPage';
import BookingPage from './pages/BookingPage';
import { AuthService } from './services/api';

// Trang đặt khám công khai — KHÔNG yêu cầu đăng nhập (đường dẫn /datkham)
const isBookingRoute = () => {
  const p = (window.location.pathname || '').toLowerCase();
  return p === '/datkham' || p.startsWith('/datkham/');
};

export default function App() {
  // Public booking page is fully standalone (no auth gate, no hooks below run).
  if (isBookingRoute()) return <BookingPage />;
  return <MainApp />;
}

function MainApp() {
  const [user, setUser] = useState(() => AuthService.getUser());
  const [view, setView] = useState('visits'); // 'visits' | 'result' | 'changePw' | 'admin' | 'adminDatkham'
  const [selectedVisit, setSelectedVisit] = useState(null);

  const handleLogin = (userData) => {
    setUser(userData);
    setSelectedVisit(null);
    setView('visits');
  };

  const handleLogout = () => {
    AuthService.logout();
    setUser(null);
    setSelectedVisit(null);
    setView('visits');
  };

  const handleSelectVisit = (maLuotKham) => {
    setSelectedVisit(maLuotKham);
    setView('result');
  };

  const backToVisits = () => {
    setSelectedVisit(null);
    setView('visits');
  };

  if (!user) return <LoginPage onLogin={handleLogin} />;

  if (view === 'changePw')
    return <ChangePasswordPage user={user} onBack={backToVisits} />;

  if (view === 'admin' && user.isAdmin)
    return <AdminUsersPage onBack={backToVisits} />;

  if (view === 'adminDatkham' && user.isAdmin)
    return <AdminDatKhamPage onBack={backToVisits} />;

  if (view === 'result' && selectedVisit)
    return <ResultPage user={user} maLuotKham={selectedVisit} onLogout={handleLogout} onBack={backToVisits} />;

  return (
    <VisitListPage
      user={user}
      onLogout={handleLogout}
      onSelectVisit={handleSelectVisit}
      onChangePassword={() => setView('changePw')}
      onOpenAdmin={() => setView('admin')}
      onOpenDatKhamAdmin={() => setView('adminDatkham')}
    />
  );
}
